import React from "react";
import { Row } from "reactstrap";
import { ItemTransport } from "./ItemTransport";

export const CardTransport = (props) => {
  const itemsData = props.data;
  const routeDetail = props.routeDetail;
  const cards = itemsData.map((item) => (
    <ItemTransport key={item.id} item={item} route={routeDetail} />
  ));
  return <Row>{cards}</Row>;
};
